var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useCallback, useContext, useMemo, useReducer } from 'react';
export var initialValue = {
    selectedSamsUser: {
        value: {
            cardType: '',
            'cipher.firstName': '',
            'cipher.lastName': '',
            'cipher.dateOfBirth': '',
            partnerId: '',
            memberId: ''
        },
        errorMessage: '',
        touched: false
    },
    isAuthorizedUserSubmitted: false,
    eligibleMembers: [],
    updateDateOfBirth: function () { },
    updateEligibleMembers: function () { },
    updateSelectedSamsUser: function () { },
    updateIsAuthorizedUserSubmitted: function () { }
};
export var ManageCardholderModalContext = createContext(initialValue);
export var useManageCardHolderModalContext = function () {
    return useContext(ManageCardholderModalContext);
};
ManageCardholderModalContext.displayName = 'ManageCardHolderModalContext';
var ManageCardholderModalContextTypes;
(function (ManageCardholderModalContextTypes) {
    ManageCardholderModalContextTypes["SET_DATE_OF_BIRTH"] = "SET_DATE_OF_BIRTH";
    ManageCardholderModalContextTypes["SET_ELIGIBLE_MEMBERS"] = "SET_ELIGIBLE_MEMBERS";
    ManageCardholderModalContextTypes["SET_SELECTED_SAMS_USER"] = "SET_SELECTED_SAMS_USER";
    ManageCardholderModalContextTypes["SET_IS_USER_SUBMITTED"] = "SET_IS_USER_SUBMITTED";
})(ManageCardholderModalContextTypes || (ManageCardholderModalContextTypes = {}));
var reducer = function (state, action) {
    switch (action.type) {
        case ManageCardholderModalContextTypes.SET_DATE_OF_BIRTH:
            return __assign(__assign({}, state), { selectedSamsUser: __assign(__assign({}, state.selectedSamsUser), { value: __assign(__assign({}, state.selectedSamsUser.value), { 'cipher.dateOfBirth': action.newDateOfBirth }) }) });
        case ManageCardholderModalContextTypes.SET_ELIGIBLE_MEMBERS:
            return __assign(__assign({}, state), { eligibleMembers: action.newEligibleMembers || [] });
        case ManageCardholderModalContextTypes.SET_SELECTED_SAMS_USER:
            return __assign(__assign({}, state), { selectedSamsUser: action.newSelectedSamsUser || initialValue.selectedSamsUser });
        case ManageCardholderModalContextTypes.SET_IS_USER_SUBMITTED:
            return __assign(__assign({}, state), { isAuthorizedUserSubmitted: action.newIsAuthorizedUserSubmitted });
        default:
            return state;
    }
};
var ManageCardholderModalContextProvider = function (_a) {
    var children = _a.children, customState = _a.customState;
    var _b = useReducer(reducer, __assign(__assign({}, initialValue), customState)), state = _b[0], dispatch = _b[1];
    var updateDateOfBirth = useCallback(function (newDateOfBirth) {
        dispatch({
            type: ManageCardholderModalContextTypes.SET_DATE_OF_BIRTH,
            newDateOfBirth: newDateOfBirth
        });
    }, []);
    var updateEligibleMembers = useCallback(function (newEligibleMembers) {
        dispatch({
            type: ManageCardholderModalContextTypes.SET_ELIGIBLE_MEMBERS,
            newEligibleMembers: newEligibleMembers
        });
    }, []);
    var updateSelectedSamsUser = useCallback(function (newSelectedSamsUser) {
        dispatch({
            type: ManageCardholderModalContextTypes.SET_SELECTED_SAMS_USER,
            newSelectedSamsUser: newSelectedSamsUser
        });
    }, []);
    var updateIsAuthorizedUserSubmitted = useCallback(function (newIsAuthorizedUserSubmitted) {
        dispatch({
            type: ManageCardholderModalContextTypes.SET_IS_USER_SUBMITTED,
            newIsAuthorizedUserSubmitted: newIsAuthorizedUserSubmitted
        });
    }, []);
    return (_jsx(ManageCardholderModalContext.Provider, __assign({ value: useMemo(function () { return (__assign(__assign({}, state), { updateDateOfBirth: updateDateOfBirth, updateEligibleMembers: updateEligibleMembers, updateSelectedSamsUser: updateSelectedSamsUser, updateIsAuthorizedUserSubmitted: updateIsAuthorizedUserSubmitted })); }, [
            state,
            updateDateOfBirth,
            updateEligibleMembers,
            updateSelectedSamsUser,
            updateIsAuthorizedUserSubmitted
        ]) }, { children: children })));
};
export default ManageCardholderModalContextProvider;
